<template>
  <b-row>
    <b-col cols="5">
      <ContractSummary class="mt-2"
                       :contract="contract"
                       :contractCategories="contractCategories"/>
    </b-col>

    <b-col cols="7">
      <p v-if="addressText" class="text-muted mt-2"> {{ $t('message.contractAddressDetails.question') }} </p>
      <p v-if="!addressText" class="text-muted mt-2"> {{ $t('message.contractAddressDetails.noAddressHint') }} </p>
      <div class="d-flex flex-wrap">
        <b-btn
          v-for="address in addresses"
          variant="transparent"
          class="hoverIE p-0 my-2 mr-4 rounded-0 btn-address"
          :key="address.id"
          @click="onSelectAddressbox(address)">
          <Infobox
            :title="getTitle(address)"
            :subtitle="address.postalCode + ' ' + address.city"
            :class="getAddressBoxClass(address)">
            <span class="infobox-icon ti-home"></span>
          </Infobox>
        </b-btn>
      </div>
    </b-col>
  </b-row>
</template>

<script>
  import ContractSummary from '@/components/contracts/ContractSummary'
  import Infobox from '@/components/common/Infobox'

  export default {
    name: 'ContractAddressDetails',
    components: {
      ContractSummary,
      Infobox
    },
    computed: {
      addressText () {
        if (this.addresses.length === 0) {
          return false
        }
        return true
      },
      addresses () {
        return this.$store.getters.addresses
      },
      contractCategories () {
        return this.$store.getters.contractCategories.map(category => {
          return {
            value: category,
            text: this.$t('enums.contractCategories.' + category)
          }
        })
      },
      contract () {
        return this.$store.getters.currentContract
      }
    },
    methods: {
      getTitle (address) {
        return `${address.street} ${address.streetNumber}`
      },
      getAddressBoxClass (address) {
        if (this.contract.address && this.contract.address.id === address.id) {
          return 'address-box__selected'
        }
        return 'address-box_un_selected'
      },
      onSelectAddressbox (address) {
        this.contract.address = address
        this.$store.commit('setCurrentContract', {...this.contract})
      }
    }
  }
</script>
<style scoped>
  .address-box__selected {
    background-color: rgba(0, 0, 0, .08);
    border: 2px solid #ccc;
  }

  .address-box_un_selected {
    border: 2px solid #fff;
  }

@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {  
  .hoverIE {
   width:100%;
  } 
  .hoverIE:hover {
    background-color: lightgray!important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/contracts/ContractAddressDetails.vue